'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.Thread = /*#__PURE__*/function () {
  function Thread(thread, code, parent) {
    (0, _classCallCheck2["default"])(this, Thread);
    this.id = Entry.generateHash();
    this._data = new Entry.Collection();
    this._code = code;
    this.changeEvent = new Entry.Event(this);
    this.changeEvent.attach(this, this.handleChange);
    this._event = null;
    this.parent = parent ? parent : code;
    this.load(thread);
  }
  return (0, _createClass2["default"])(Thread, [{
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "load",
    value: function load() {
      var thread = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var mode = arguments.length > 1 ? arguments[1] : undefined;
      if (!(thread instanceof Array)) {
        return console.error('thread must be array');
      }
      for (var i = 0; i < thread.length; i++) {
        var block = thread[i];
        if (block instanceof Entry.Block || block instanceof Entry.Comment || block.isDummy) {
          block.setThread(this);
          this._data.push(block);
        } else if (block.type === 'comment') {
          var commment = new Entry.Comment(block);
          commment.setThread(this);
          this._data.push(commment);
        } else {
          this._data.push(new Entry.Block(block, this));
        }
      }
      var codeView = this._code.view;
      if (codeView) {
        this.createView(codeView.board, mode);
      }
      this.resetEvent();
      return this;
    }
  }, {
    key: "registerEvent",
    value: function registerEvent(block, eventType) {
      this._event = eventType;
      this._code.registerEvent(block, eventType);
    }
  }, {
    key: "unregisterEvent",
    value: function unregisterEvent(block, eventType) {
      this._code.unregisterEvent(block, eventType);
    }
  }, {
    key: "createView",
    value: function createView(board, mode) {
      if (!this.view) {
        this.view = new Entry.ThreadView(this, board);
      }
      this.getBlocks().forEach(function (b) {
        var view;
        if (b.createView) {
          view = b.createView(board, mode);
        } else if (b.createComment) {
          view = b.createComment(board);
        }
        return view;
      });
    }
  }, {
    key: "destroyView",
    value: function destroyView() {
      this.view = null;
      this._data.map(function (b) {
        return b.destroyView();
      });
    }
  }, {
    key: "separate",
    value: function separate(block, count, index) {
      if (!this._data.has(block.id)) {
        return;
      }
      this._code.createThread(this._data.splice(this._data.indexOf(block), count), index);
      this.resetEvent();
      this.changeEvent.notify();
    }
  }, {
    key: "cut",
    value: function cut(block) {
      var splicedData = this._data.splice(this._data.indexOf(block));
      this.resetEvent();
      this.changeEvent.notify();
      return splicedData;
    }
  }, {
    key: "insertByBlock",
    value: function insertByBlock(block, newBlocks) {
      var _this$_data;
      var index = block ? this._data.indexOf(block) : -1;
      for (var i = 0; i < newBlocks.length; i++) {
        newBlocks[i].setThread(this);
      }
      (_this$_data = this._data).splice.apply(_this$_data, (0, _toConsumableArray2["default"])([index + 1, 0].concat(newBlocks)));
      this.resetEvent();
      this.changeEvent.notify();
    }
  }, {
    key: "insertToTop",
    value: function insertToTop(newBlock) {
      newBlock.setThread(this);
      this._data.unshift.apply(this._data, [newBlock]);
      this.resetEvent();
      this.changeEvent.notify();
    }
  }, {
    key: "clone",
    value: function clone(code, mode) {
      var newThread = new Entry.Thread([], code || this._code);
      return newThread.load(this.getBlocks().reduce(function (acc, block) {
        return [].concat((0, _toConsumableArray2["default"])(acc), [block.clone(newThread)]);
      }, []), mode);
    }
  }, {
    key: "toJSON",
    value: function toJSON(isNew) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var excludeData = arguments.length > 2 ? arguments[2] : undefined;
      var option = arguments.length > 3 ? arguments[3] : undefined;
      if (index instanceof Entry.Block) {
        index = this.indexOf(index);
      }
      var array = [];
      var data = this._data;
      for (index; index < data.length; index++) {
        var block = data[index];
        if (block instanceof Entry.Block) {
          array.push(block.toJSON(isNew, excludeData, option));
        } else if (block instanceof Entry.Comment) {
          array.push(block.toJSON());
        }
      }
      return array;
    }
  }, {
    key: "destroy",
    value: function destroy(animate, isNotForce) {
      if (this.view) {
        this.view.destroy(animate);
      }
      this.getBlocks().reverse().forEach(function (block) {
        return block.destroy(animate, null, isNotForce);
      });
      if (!this._data.length) {
        this._code.destroyThread(this, false);
      }
    }
  }, {
    key: "getBlock",
    value: function getBlock(index) {
      return this._data[index];
    }
  }, {
    key: "getBlocks",
    value: function getBlocks() {
      return this._data.map(_.identity);
    }
  }, {
    key: "countBlock",
    value: function countBlock() {
      return this.getBlocks().reduce(function (count, block) {
        if (!block.type) {
          return count;
        }
        count++;
        return (block.statements || []).reduce(function (count, statement) {
          return count += statement.countBlock();
        }, count);
      }, 0);
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      if (this._data.length === 0) {
        this.destroy();
      }
    }
  }, {
    key: "getCode",
    value: function getCode() {
      return this._code;
    }
  }, {
    key: "setCode",
    value: function setCode(code) {
      this._code = code;
    }
  }, {
    key: "spliceBlock",
    value: function spliceBlock(block) {
      this._data.remove(block);
      this.resetEvent();
      this.changeEvent.notify();
    }
  }, {
    key: "getFirstBlock",
    value: function getFirstBlock() {
      return this._data[0];
    }
  }, {
    key: "getPrevBlock",
    value: function getPrevBlock(block) {
      return this._data.at(this._data.indexOf(block) - 1);
    }
  }, {
    key: "getNextBlock",
    value: function getNextBlock(block) {
      return this._data.at(this._data.indexOf(block) + 1);
    }
  }, {
    key: "getLastBlock",
    value: function getLastBlock() {
      return this._data.at(this._data.length - 1);
    }
  }, {
    key: "getRootBlock",
    value: function getRootBlock() {
      return this._data.at(0);
    }
  }, {
    key: "hasBlockType",
    value: function hasBlockType(type) {
      for (var i = 0; i < this._data.length; i++) {
        if (inspectBlock(this._data[i])) {
          return true;
        }
      }
      return false;
      function inspectBlock(block) {
        if (Array.isArray(type) && type.includes(block.type)) {
          return true;
        } else if (type === block.type) {
          return true;
        }
        var params = block.params || [];
        for (var k = 0; k < params.length; k++) {
          var param = params[k];
          if (param && param.constructor == Entry.Block) {
            if (inspectBlock(param)) {
              return true;
            }
          }
        }
        var statements = block.statements;
        if (statements) {
          for (var j = 0; j < statements.length; j++) {
            if (statements[j].hasBlockType(type)) {
              return true;
            }
          }
        }
        return false;
      }
    }
  }, {
    key: "getCount",
    value: function getCount(startBlock) {
      var result = this._data.length;
      if (startBlock) {
        result -= this._data.indexOf(startBlock);
      }
      return result;
    }
  }, {
    key: "indexOf",
    value: function indexOf(block) {
      return this._data.indexOf(block);
    }
  }, {
    key: "pointer",
    value: function pointer() {
      var _pointer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var block = arguments.length > 1 ? arguments[1] : undefined;
      if (block) {
        _pointer.unshift(this.indexOf(block));
      }
      var parent = this.parent;
      if (parent instanceof Entry.Block) {
        _pointer.unshift(parent.indexOfStatements(this));
      }
      if (this._code === parent) {
        var _this$_data$ = this._data[0],
          x = _this$_data$.x,
          y = _this$_data$.y;
        return [x, y, this._code.indexOf(this)].concat((0, _toConsumableArray2["default"])(_pointer));
      }
      return parent.pointer(_pointer);
    }
  }, {
    key: "getBlockIndex",
    value: function getBlockIndex(block) {
      return this.getBlocks().indexOf(block);
    }
  }, {
    key: "getBlockList",
    value: function getBlockList(excludePrimitive, type, index) {
      return _.chain(this._data).map(function (block) {
        if (block.constructor !== Entry.Block) {
          return;
        }
        if (Array.isArray(type)) {
          return type.reduce(function (acc, type) {
            return acc.concat(block.getBlockList(excludePrimitive, type));
          }, []);
        } else {
          return block.getBlockList(excludePrimitive, type);
        }
      }).flatten().compact().value();
    }
  }, {
    key: "stringify",
    value: function stringify(excludeData, isNew, index) {
      return JSON.stringify(this.toJSON(isNew, index, excludeData));
    }
  }, {
    key: "isInOrigin",
    value: function isInOrigin() {
      var block = this.getFirstBlock();
      return block && block.isInOrigin();
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      var view = this.view;
      if (_.isEmpty(query)) {
        return view.svgGroup;
      }
      query = (0, _toConsumableArray2["default"])(query);
      var key = query.shift();
      if (key === 'magnet') {
        return view.getMagnet('next');
      }
    }
  }, {
    key: "isParamBlockType",
    value: function isParamBlockType() {
      return false;
    }
  }, {
    key: "isGlobal",
    value: function isGlobal() {
      return this._code === this.parent;
    }
  }, {
    key: "hasData",
    value: function hasData() {
      return Boolean(this._data.length);
    }
  }, {
    key: "resetEvent",
    value: function resetEvent() {
      var _block$_schema;
      var block = this.getFirstBlock();
      if (block && this._event !== (block === null || block === void 0 || (_block$_schema = block._schema) === null || _block$_schema === void 0 ? void 0 : _block$_schema.event)) {
        var _block$_schema2;
        this._event = block === null || block === void 0 || (_block$_schema2 = block._schema) === null || _block$_schema2 === void 0 ? void 0 : _block$_schema2.event;
      }
    }
  }]);
}();